export default "https://cdn-static.gokick.com/assets/b11b69440b74c450e5ca5f7ba176f3cdc3a0fffe/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";